import React from 'react';

// アカウント編集確認ポップアップコンポーネント
export const AccountEditConfirmationPopup = ({
  showConfirmationPopup,
  formData,
  closeConfirmationPopup,
  confirmEdit,
  showEmail = true
}) => {
  if (!showConfirmationPopup) return null;
  
  return (
    <div className="confirmation-popup-overlay">
      <div className="confirmation-popup-container">
        <div className="confirmation-popup-content">
          <h2 className="confirmation-title">アカウント編集確認</h2>
          
          <div className="confirmation-details">
            <div className="comment-header u-mt-medium">アカウント情報</div>
            <div className="confirmation-files">
              <div className="confirmation-file-item font-large">
                <div className="file-path">ユーザー名: {formData.username}</div>
              </div>
              {showEmail && (
                <div className="confirmation-file-item font-large">
                  <div className="file-path">アカウント名（メールアドレス）: {formData.accountname}</div>
                </div>
              )}
              <div className="confirmation-file-item font-large">
                <div className="file-path">パスワード: ********</div>
              </div>
            </div>
            
            <div className="confirmation-comment">
              <div className="comment-header-error">注意事項</div>
              <div className="comment-content comment-content--error">
                上記の内容でアカウント情報を更新します。
                変更を保存してよいですか？
              </div>
            </div>
          </div>
          
          <div className="action-buttons c-max-mini c-m-center">
            <button 
              className="button button-secondary button-medium" 
              onClick={closeConfirmationPopup}
            >
              キャンセル
            </button>
            <button 
              className="btn btn-primary button-medium" 
              onClick={confirmEdit}
            >
              変更を保存する
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountEditConfirmationPopup;